<template>
    <div>
      <p>健康是人类福祉的保证，这就是为什么学会防止健康状况恶化是如此重要，这一点是如此的真实，以至于它常常取决于所做的决定，这样我们就有了更具抵抗力的身体，这就是为什么意识到我们的选择和习惯是如此重要，这些习惯引导我们拥有一个高质量的生活并坚持下去。</p>
      <p>在生物能源中心，您将在其中找到各种感兴趣的主题，我们的服务可以是现场授课的也可以是在线的。</p>
        <ul style="margin-top: auto">
        <li>了解你的身体</li>
        <li>健康习惯</li>
        <li>良好水合作用的重要性</li>
        <li>健康食物</li>
        <li>预防和治疗循环系统的常见疾病</li>
        <li>糖循环</li>
        <li>过敏</li>
        <li>糖尿病</li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 's5'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/s5.vue